import React, { useEffect, useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { SaveIcon, SearchIcon, SortAscIcon, SortDescIcon } from 'lucide-react';
export function NotifichePreventiveTab() {
  const [giorniPreavviso, setGiorniPreavviso] = useState(7);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('ragioneSociale');
  const [sortDirection, setSortDirection] = useState('asc');
  const [clienti, setClienti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectAll, setSelectAll] = useState(false);
  // Carica i dati dei clienti
  useEffect(() => {
    // Simulazione di caricamento dati dal server
    setTimeout(() => {
      const dummyData = [{
        id: '1',
        ragioneSociale: 'Acme Srl',
        piva: '12345678901',
        mediaGiorniRitardo: 8,
        notificheAttive: true
      }, {
        id: '2',
        ragioneSociale: 'TechSolutions Spa',
        piva: '98765432101',
        mediaGiorniRitardo: 0,
        notificheAttive: true
      }, {
        id: '3',
        ragioneSociale: 'Industria Meccanica Srl',
        piva: '45678912301',
        mediaGiorniRitardo: 15,
        notificheAttive: false
      }, {
        id: '4',
        ragioneSociale: 'Logistica Express Srl',
        piva: '78901234561',
        mediaGiorniRitardo: 22,
        notificheAttive: false
      }, {
        id: '5',
        ragioneSociale: 'Alimentari Freschi Spa',
        piva: '56789012341',
        mediaGiorniRitardo: 5,
        notificheAttive: true
      }, {
        id: '6',
        ragioneSociale: 'Edilizia Moderna Srl',
        piva: '23456789011',
        mediaGiorniRitardo: 12,
        notificheAttive: true
      }, {
        id: '7',
        ragioneSociale: 'GreenEnergy Spa',
        piva: '89012345671',
        mediaGiorniRitardo: 0,
        notificheAttive: true
      }, {
        id: '8',
        ragioneSociale: 'Retail Fashion Srl',
        piva: '34567890121',
        mediaGiorniRitardo: 18,
        notificheAttive: false
      }];
      setClienti(dummyData);
      setLoading(false);
    }, 1000);
  }, []);
  // Gestisce il cambio del numero di giorni di preavviso
  const handleGiorniPreavvisoChange = e => {
    const value = parseInt(e.target.value);
    if (value >= 0 && value <= 31) {
      setGiorniPreavviso(value);
    }
  };
  // Gestisce il cambio dello stato delle notifiche per un singolo cliente
  const handleToggleNotifiche = id => {
    setClienti(clienti.map(cliente => cliente.id === id ? {
      ...cliente,
      notificheAttive: !cliente.notificheAttive
    } : cliente));
  };
  // Gestisce il cambio dello stato delle notifiche per tutti i clienti
  const handleToggleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    setClienti(clienti.map(cliente => ({
      ...cliente,
      notificheAttive: newSelectAll
    })));
  };
  // Gestisce il cambio dell'ordinamento
  const handleSort = field => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };
  // Filtra e ordina i clienti
  const filteredClienti = clienti.filter(cliente => cliente.ragioneSociale.toLowerCase().includes(searchTerm.toLowerCase()) || cliente.piva.includes(searchTerm));
  const sortedClienti = [...filteredClienti].sort((a, b) => {
    if (sortField === 'mediaGiorniRitardo') {
      return sortDirection === 'asc' ? a[sortField] - b[sortField] : b[sortField] - a[sortField];
    } else {
      return sortDirection === 'asc' ? a[sortField].localeCompare(b[sortField]) : b[sortField].localeCompare(a[sortField]);
    }
  });
  // Renderizza l'icona di ordinamento
  const renderSortIcon = field => {
    if (sortField !== field) return null;
    return sortDirection === 'asc' ? <SortAscIcon className="h-4 w-4 ml-1" data-id="element-129" /> : <SortDescIcon className="h-4 w-4 ml-1" data-id="element-130" />;
  };
  // Salva la configurazione
  const handleSaveConfig = () => {
    alert('Configurazione salvata con successo');
  };
  return <Card data-id="element-131">
      <h3 className="text-lg font-medium text-gray-900 mb-6" data-id="element-132">
        Configurazione Notifiche Preventive
      </h3>
      <div className="mb-6" data-id="element-133">
        <label htmlFor="giorniPreavviso" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-134">
          Giorni di preavviso per l'invio delle notifiche
        </label>
        <div className="flex items-center" data-id="element-135">
          <input type="number" id="giorniPreavviso" min="0" max="31" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-32 shadow-sm sm:text-sm border-gray-300 rounded-md" value={giorniPreavviso} onChange={handleGiorniPreavvisoChange} data-id="element-136" />
          <span className="ml-2 text-sm text-gray-500" data-id="element-137">
            giorni prima della scadenza
          </span>
        </div>
        <p className="mt-2 text-sm text-gray-500" data-id="element-138">
          Imposta il numero di giorni prima della scadenza in cui inviare la
          notifica preventiva ai clienti. Il valore deve essere compreso tra 0 e
          31 giorni.
        </p>
      </div>
      <div className="mb-4 flex justify-between items-center" data-id="element-139">
        <div className="w-full max-w-lg" data-id="element-140">
          <div className="relative mt-1 rounded-md shadow-sm" data-id="element-141">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-142">
              <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" data-id="element-143" />
            </div>
            <input type="text" className="block w-full rounded-md border-gray-300 pl-10 focus:border-blue-500 focus:ring-blue-500 sm:text-sm" placeholder="Cerca per ragione sociale o partita IVA..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-144" />
          </div>
        </div>
      </div>
      <div className="overflow-x-auto" data-id="element-145">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-146">
          <thead className="bg-gray-50" data-id="element-147">
            <tr data-id="element-148">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-149">
                <div className="flex items-center" data-id="element-150">
                  <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={selectAll} onChange={handleToggleSelectAll} data-id="element-151" />
                  <span className="ml-2" data-id="element-152">Notifiche</span>
                </div>
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('ragioneSociale')} data-id="element-153">
                <div className="flex items-center" data-id="element-154">
                  Ragione Sociale
                  {renderSortIcon('ragioneSociale')}
                </div>
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('piva')} data-id="element-155">
                <div className="flex items-center" data-id="element-156">
                  Partita IVA
                  {renderSortIcon('piva')}
                </div>
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => handleSort('mediaGiorniRitardo')} data-id="element-157">
                <div className="flex items-center" data-id="element-158">
                  Media Giorni Ritardo
                  {renderSortIcon('mediaGiorniRitardo')}
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-159">
            {loading ? <tr data-id="element-160">
                <td colSpan={4} className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-161">
                  Caricamento in corso...
                </td>
              </tr> : sortedClienti.length === 0 ? <tr data-id="element-162">
                <td colSpan={4} className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-163">
                  Nessun cliente trovato
                </td>
              </tr> : sortedClienti.map(cliente => <tr key={cliente.id} className="hover:bg-gray-50" data-id="element-164">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-165">
                    <input type="checkbox" className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded" checked={cliente.notificheAttive} onChange={() => handleToggleNotifiche(cliente.id)} data-id="element-166" />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-167">
                    {cliente.ragioneSociale}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-168">
                    {cliente.piva}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-169">
                    <span className={`${cliente.mediaGiorniRitardo > 15 ? 'text-red-600' : cliente.mediaGiorniRitardo > 5 ? 'text-yellow-600' : 'text-green-600'}`} data-id="element-170">
                      {cliente.mediaGiorniRitardo} giorni
                    </span>
                  </td>
                </tr>)}
          </tbody>
        </table>
      </div>
      <div className="mt-6 flex justify-end" data-id="element-171">
        <Button type="button" onClick={handleSaveConfig} icon={<SaveIcon className="h-4 w-4 mr-2" data-id="element-173" />} data-id="element-172">
          Salva Configurazione
        </Button>
      </div>
    </Card>;
}